var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBodyMini = function SvgBodyMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87999 6.00004C10.6164 6.00004 11.2133 5.40309 11.2133 4.66671C11.2133 3.93033 10.6164 3.33337 9.87999 3.33337C9.14362 3.33337 8.54666 3.93033 8.54666 4.66671C8.54666 5.40309 9.14362 6.00004 9.87999 6.00004Z",
    fill: "#00A5B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4733 7.40671C12.2133 7.14671 11.7667 6.66671 10.9 6.66671C10.76 6.66671 9.95333 6.66671 9.20666 6.66671C7.37333 6.66004 5.87999 5.16671 5.87999 3.33337H4.54666C4.54666 5.44004 5.95333 7.22671 7.87999 7.80671V16.6667H9.21333V12.6667H10.5467V16.6667H11.88V8.70004L14.5133 11.3334L15.4533 10.3934L12.4733 7.40671Z",
    fill: "#00A5B9"
  })));
};
export default SvgBodyMini;